import { Controller } from '@hotwired/stimulus';


export default class extends Controller {
  static values = { url: String, csvDownloadId: Number };

    connect() {
        console.log('mark-as-seen controller connected');
    }
  download(event) {
    event.preventDefault();
    console.log('inside mark-as-seen#download', `id: ${this.csvDownloadIdValue}`)
   fetch(`/admin/csv_downloads/${this.csvDownloadIdValue}/mark_as_seen`, {
     method: 'PATCH',
     headers: {
       'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
       Accept: 'text/vnd.turbo-stream.html',
       'Content-Type': 'application/json',
     },
     body: JSON.stringify({ seen: true }),
   })
     .then((response) => {
       if (response.ok) {
            window.open(this.urlValue, '_blank');
           console.log(`CSV Download ID: ${this.csvDownloadIdValue}  is marked seen,`)
       } else {
         console.error('Error marking download as seen');
       }
     })
     .catch((err) => console.error(err));
  }
}
